import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router";

import {
  toggleModal,
  changePatient,
} from "app/store/transmission/slice/transmissionSlice";

import { getRedirectPath } from "utils/routes.util";
import PatientModal from "./PatientModal";

const PatientProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patientId } = useParams();

  const { isPatientModal } = useSelector((state) => state.transmission);

  useEffect(() => {
    if (!patientId) {
      const redirectPath = getRedirectPath();
      navigate(redirectPath, { replace: true });
      return;
    }

    dispatch(
      changePatient({
        patientId,
      })
    );

    dispatch(toggleModal({ type: "patient", value: true }));
  }, [patientId]);

  if (!isPatientModal) return null;

  return <PatientModal />;
};

export default PatientProfile;
